import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: 'previousWeekUsageCategory'
})
export class PreviousWeekUsageCategoryPipe implements PipeTransform {
  transform(previousWeekUsage: number | string) {
    const minutes = typeof previousWeekUsage === 'string' ? parseInt(previousWeekUsage) : previousWeekUsage;
    if (minutes < 30) {
      return 'red';
    } else if (minutes < 60) {
      return 'yellow';
    } else if (minutes < 150) {
      return 'green';
    }
    return 'purple';
  }
}
